import Button from "@mui/material/Button";
export default function BotaoText(props) {
  return (
    <Button variant="text" {...props}>
      {props.children}
    </Button>
  );
}
